import {call, put} from 'redux-saga/effects';
import DealerActions from '../redux/DealerRedux';
import DealersActions from '../redux/DealersRedux';
import MessagesActions from '../redux/MessagesRedux';

export function * getDealer(api, action) {
  const response = yield call(api.getDealer, action.id);

  if (response.ok) {
    yield put(DealerActions.dealerSuccess(response.data));
  } else {
    yield put(DealerActions.dealerFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

export function * addDealer(api, action) {
  const response = yield call(api.addDealer, {...action.data});

  if (response.ok) {
    yield put(DealerActions.dealerSuccess(response.data));
    yield put(DealersActions.dealersSuccess(null));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'dealerAdd', title: 'Запись успешно создана'}));
  } else {
    yield put(DealerActions.dealerFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

export function * updateDealer(api, action) {
  const response = yield call(api.editDealer, {...action.data});

  if (response.ok) {
    yield put(DealerActions.dealerSuccess(response.data));
    yield put(DealersActions.dealersSuccess(null));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'dealerUpdate', title: 'Запись успешно обновлена'}));
  } else {
    yield put(DealerActions.dealerFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

export function * deleteDealer(api, action) {
  const response = yield call(api.deleteDealer, action.id);

  if (response.ok) {
    yield put(DealerActions.dealerSuccess(null));
    yield put(DealersActions.dealersSuccess(null));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'dealerDelete', title: 'Запись успешно удалена'}));
  } else {
    yield put(DealerActions.dealerFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}
